(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 96740:
/***/ (function(module) {

/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/
(function(e,g){ true?module.exports=g():0})(this,function(){function e(b,a){if(!(this instanceof e))return new e(b,a);a=Object.assign({},m,a);var d=Math.pow(10,a.precision);this.intValue=b=g(b,a);this.value=b/d;a.increment=a.increment||1/d;a.groups=a.useVedic?n:p;this.s=a;this.p=d}function g(b,a){var d=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;var c=a.decimal;
var h=a.errorOnInvalid,k=a.fromCents,l=Math.pow(10,a.precision),f=b instanceof e;if(f&&k)return b.intValue;if("number"===typeof b||f)c=f?b.value:b;else if("string"===typeof b)h=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),c=(c=b.replace(/\((.*)\)/,"-$1").replace(h,"").replace(c,"."))||0;else{if(h)throw Error("Invalid Input");c=0}k||(c=(c*l).toFixed(4));return d?Math.round(c):c}var m={symbol:"$",separator:",",decimal:".",errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#",format:function(b,
a){var d=a.pattern,c=a.negativePattern,h=a.symbol,k=a.separator,l=a.decimal;a=a.groups;var f=(""+b).replace(/^-/,"").split("."),q=f[0];f=f[1];return(0<=b.value?d:c).replace("!",h).replace("#",q.replace(a,"$1"+k)+(f?l+f:""))},fromCents:!1},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;e.prototype={add:function(b){var a=this.s,d=this.p;return e((this.intValue+g(b,a))/(a.fromCents?1:d),a)},subtract:function(b){var a=this.s,d=this.p;return e((this.intValue-g(b,a))/(a.fromCents?1:d),a)},multiply:function(b){var a=
this.s;return e(this.intValue*b/(a.fromCents?1:Math.pow(10,a.precision)),a)},divide:function(b){var a=this.s;return e(this.intValue/g(b,a,!1),a)},distribute:function(b){var a=this.intValue,d=this.p,c=this.s,h=[],k=Math[0<=a?"floor":"ceil"](a/b),l=Math.abs(a-k*b);for(d=c.fromCents?1:d;0!==b;b--){var f=e(k/d,c);0<l--&&(f=f[0<=a?"add":"subtract"](1/d));h.push(f)}return h},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s;return"function"===
typeof b?b(this,a):a.format(this,Object.assign({},a,b))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return e});


/***/ }),

/***/ 44174:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 81119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 55189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(44174),
    baseAggregator = __webpack_require__(81119),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 7739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    createAggregator = __webpack_require__(55189);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 74223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(43915);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 43915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_pricing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/currency.js/dist/currency.min.js
var currency_min = __webpack_require__(96740);
var currency_min_default = /*#__PURE__*/__webpack_require__.n(currency_min);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./util/hooks/useUnsubscribe.js
var useUnsubscribe = __webpack_require__(72038);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./util/format.ts + 9 modules
var format = __webpack_require__(16685);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/zonedTimeToUtc/index.js
var zonedTimeToUtc = __webpack_require__(41036);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/ui/card.tsx
var card = __webpack_require__(64345);
// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
;// CONCATENATED MODULE: ./components/cards/PricingCard.tsx











var PricingCard = function(props) {
    var featuresByLevel = Object.values(groupBy_default()(props.features, "level"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Zb, {
        className: (0,utils.cn)("bg-card flex flex-col items-center shadow-lg p-4", {
            "bg-teal-500": props.featured,
            "text-white": props.featured
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h3",
                children: props.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                children: props.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: props.imgSrc,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,utils.cn)("flex justify-center items-baseline my-4", {
                            "text-white": props.featured
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "mr-2 text-2xl font-extrabold",
                                children: [
                                    props.price,
                                    props.currency
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "/month"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4",
                children: featuresByLevel.map(function(featuresLevel, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-disc list-inside marker:text-teal-300",
                        children: featuresLevel.map(function(f) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: f.label
                                    }
                                })
                            }, f.id);
                        })
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingActiveSubscriptionActions, {
                id: props.id,
                featured: props.featured,
                title: props.title,
                onSelect: props.onSelect
            })
        ]
    });
};
var PricingActiveSubscriptionActions = function(param) {
    var id = param.id, featured = param.featured, title = param.title, onSelect = param.onSelect;
    var ref, ref1;
    var auth = (0,util_auth/* useAuth */.aC)();
    var user = auth === null || auth === void 0 ? void 0 : auth.user;
    var subscription = user === null || user === void 0 ? void 0 : user.subscription;
    var futureSubscription = user === null || user === void 0 ? void 0 : user.futureSubscription;
    var hasActiveSubscription = !!(subscription === null || subscription === void 0 ? void 0 : subscription.id);
    var isTrialSubscriptionActive = !!(subscription === null || subscription === void 0 ? void 0 : subscription.is_trial);
    var tz = user === null || user === void 0 ? void 0 : user.timezone;
    var handleUnsubscribe = (0,useUnsubscribe/* useUnsubscribe */.p)();
    var isActiveSubscription = (subscription === null || subscription === void 0 ? void 0 : subscription.product_id) === id && !(subscription === null || subscription === void 0 ? void 0 : subscription.is_trial);
    var isFutureSubscription = (futureSubscription === null || futureSubscription === void 0 ? void 0 : futureSubscription.product_id) === id;
    var statusText = isFutureSubscription ? "next plan" : "subscribed";
    var currentSubscription = isFutureSubscription ? futureSubscription : subscription;
    var subscriptionEndDate = (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.is_trial) ? currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.end_time : currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.next_payment_time;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isActiveSubscription || isFutureSubscription ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: statusText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: isFutureSubscription ? "Active from ".concat((0,format/* formatDate */.p6)({
                            ts: (0,zonedTimeToUtc/* default */.Z)(futureSubscription === null || futureSubscription === void 0 ? void 0 : (ref = futureSubscription.start_time) === null || ref === void 0 ? void 0 : ref.date, futureSubscription === null || futureSubscription === void 0 ? void 0 : (ref1 = futureSubscription.start_time) === null || ref1 === void 0 ? void 0 : ref1.timezone).getTime() / 1000,
                            tz: tz
                        })) : hasActiveSubscription ? "Next payment ".concat((0,format/* formatDate */.p6)({
                            ts: (0,zonedTimeToUtc/* default */.Z)(subscriptionEndDate === null || subscriptionEndDate === void 0 ? void 0 : subscriptionEndDate.date, subscriptionEndDate === null || subscriptionEndDate === void 0 ? void 0 : subscriptionEndDate.timezone).getTime() / 1000,
                            tz: tz
                        })) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        size: "sm",
                        variant: "destructive",
                        onClick: handleUnsubscribe,
                        children: "Cancel plan"
                    })
                ]
            }) : null,
            !isFutureSubscription && !isActiveSubscription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                variant: featured ? "default" : "outline",
                onClick: onSelect,
                children: hasActiveSubscription && !isTrialSubscriptionActive ? "Switch plan" : "Choose ".concat(title)
            }) : null
        ]
    });
};
/* harmony default export */ var cards_PricingCard = (PricingCard);

;// CONCATENATED MODULE: ./components/PricingOptionsList.tsx




var PricingOptionsList = function(param) {
    var items = param.items, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid gap-6 lg:grid-cols-3",
        children: items.map(function(p, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,utils.cn)("[&>*]:h-full", {
                    "scale-105 ": p.featured
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_PricingCard, {
                    id: p.id,
                    imgSrc: idx < 3 ? "/media/plan-".concat(idx + 1, ".svg") : "/media/pricing-plan-img.svg",
                    title: p.title,
                    price: p.price,
                    currency: p.currency,
                    duration: p.duration,
                    trialDuration: p.trialDuration,
                    description: p.description,
                    featured: p.featured,
                    active: p.active,
                    features: p.features,
                    hasActiveSubscription: p.hasActiveSubscription,
                    isTrialSubscriptionActive: p.isTrialSubscriptionActive,
                    onSelect: function() {
                        onSelect(p);
                    }
                }, p.id)
            }, p.title);
        })
    });
};
/* harmony default export */ var components_PricingOptionsList = (PricingOptionsList);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/Typography.js
var Typography = __webpack_require__(57731);
// EXTERNAL MODULE: ./icons/icon-checklight-24.svg
var icon_checklight_24 = __webpack_require__(57121);
;// CONCATENATED MODULE: ./icons/icon_close_24.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconClose24 = function SvgIconClose24(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.3,
    d: "M19.018 6.41 17.608 5l-5.59 5.59L6.428 5l-1.41 1.41 5.59 5.59-5.59 5.59L6.428 19l5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59 5.59-5.59Z"
  })));
};
/* harmony default export */ var icon_close_24 = (SvgIconClose24);
// EXTERNAL MODULE: ./components/PricingComparsionTable.module.scss
var PricingComparsionTable_module = __webpack_require__(26546);
var PricingComparsionTable_module_default = /*#__PURE__*/__webpack_require__.n(PricingComparsionTable_module);
;// CONCATENATED MODULE: ./components/PricingComparisonTable.js









var PricingComparisonTable = function(param) {
    var plans = param.plans, table = param.table, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((PricingComparsionTable_module_default())["pricing-comparison-table"], "table-responsive"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            className: "table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Our",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "plans"
                                        ]
                                    }),
                                    fontSize: 3,
                                    fontWeight: "bold"
                                })
                            }),
                            plans.map(function(p, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                    className: (0,clsx_m/* default */.Z)((PricingComparsionTable_module_default())["pricing-comparison-table__cell"], (0,_define_property/* default */.Z)({}, (PricingComparsionTable_module_default())["pricing-comparison-table__cell--featured"], p.featured)),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: p.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (PricingComparsionTable_module_default())["pricing-comparison-table__price-info"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (PricingComparsionTable_module_default())["pricing-comparison-table__price-text"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: p.price
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (PricingComparsionTable_module_default())["pricing-comparison-table__currency"],
                                                        children: p.currency
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (PricingComparsionTable_module_default())["pricing-comparison-table__duration"],
                                                        children: "month"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, idx);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: table.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: category.category_title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                                    ]
                                }),
                                category.features.map(function(f, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: (0,clsx_m/* default */.Z)((PricingComparsionTable_module_default())["pricing-comparison-table__row"], (0,_define_property/* default */.Z)({}, (PricingComparsionTable_module_default())["pricing-comparison-table__row--striped"], index % 2 === 0)),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: f.label
                                            }),
                                            f.packages_configuration.map(function(packageConfig, packageIndex) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (0,clsx_m/* default */.Z)((PricingComparsionTable_module_default())["pricing-comparison-table__cell"], (0,_define_property/* default */.Z)({}, (PricingComparsionTable_module_default())["pricing-comparison-table__cell--highlighted"], !!packageConfig.enabled)),
                                                    children: packageConfig.description ? packageConfig.description : packageConfig.enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_checklight_24/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_close_24, {})
                                                }, packageIndex);
                                            })
                                        ]
                                    }, f.label);
                                })
                            ]
                        }, category.category_title);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            plans.map(function(p, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: !p.active || p.isTrialSubscriptionActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        size: "sm",
                                        variant: p.featured ? "default" : "outline",
                                        onClick: function() {
                                            onSelect(p);
                                        },
                                        children: p.hasActiveSubscription && !p.isTrialSubscriptionActive ? "Switch plan" : "Choose ".concat(p.title)
                                    }) : null
                                }, idx);
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_PricingComparisonTable = (PricingComparisonTable);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/TextParser.tsx
var TextParser = __webpack_require__(67679);
;// CONCATENATED MODULE: ./components/PricingSection.tsx












function PricingSection(param) {
    var title = param.title, comparisonTable = param.comparisonTable, description = param.description, plans = param.plans, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "pb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "h1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextParser/* default */.Z, {
                            text: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                    children: [
                        "During the initial ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "free 14-day"
                        }),
                        " trial with the Challenger functionality you can choose one of the below membership plans."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PricingOptionsList, {
                    items: plans.map(function(p) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                            features: p.features.filter(function(f) {
                                return f.enabled && f.level === 100;
                            })
                        });
                    }),
                    onSelect: onSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "link-primary",
                                children: "Contact us"
                            })
                        }),
                        " ",
                        "to get a corporate offer"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h2",
                className: "mb-6",
                children: "Compare features"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PricingComparisonTable, {
                plans: plans,
                table: comparisonTable,
                onSelect: onSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Zb, {
                    className: (0,utils.cn)("border-0 bg-teal-100 relative"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardHeader */.Ol, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardTitle */.ll, {
                                    children: "Still have a question?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardDescription */.SZ, {
                                    children: "If you have any questions, get in touch with us – we are happy to help you to choose the best plan for your needs."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardFooter */.eW, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/contact",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "outline",
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Ask a Question"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./util/pricing.js
var pricing = __webpack_require__(8637);
;// CONCATENATED MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.15.0",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
};

// own script injection.

var stripePromise$1 = Promise.resolve().then(function () {
  return loadScript(null);
});
var loadCalled = false;
stripePromise$1["catch"](function (err) {
  if (!loadCalled) {
    console.warn(err);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now();
  return stripePromise$1.then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};



;// CONCATENATED MODULE: ./util/stripe.js

var stripe_stripePromise;
var getStripe = function(publicKey) {
    if (!stripe_stripePromise) {
        stripe_stripePromise = loadStripe(publicKey);
    }
    return stripe_stripePromise;
};

// EXTERNAL MODULE: ./components/TrialModal.tsx
var TrialModal = __webpack_require__(32487);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/pricing.js












function PricingPage(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isTrialModalOpen = ref3[0], setIsTrialModalOpen = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var _content = props.content, content = _content === void 0 ? {} : _content, _plans = props.plans, plans = _plans === void 0 ? [] : _plans;
    var auth = (0,util_auth/* useAuth */.aC)();
    var router = (0,next_router.useRouter)();
    var futureSubscription = auth === null || auth === void 0 ? void 0 : (ref = auth.user) === null || ref === void 0 ? void 0 : ref.futureSubscription;
    var currentSubscription = auth === null || auth === void 0 ? void 0 : (ref1 = auth.user) === null || ref1 === void 0 ? void 0 : ref1.subscription;
    var isTrialSubscriptionActive = auth === null || auth === void 0 ? void 0 : (ref2 = auth.user) === null || ref2 === void 0 ? void 0 : ref2.isTrialSubscriptionActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: content.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrialModal/* TrialModal */.B, {
                open: isTrialModalOpen,
                onClose: function() {
                    setIsTrialModalOpen(false);
                },
                onActivateTrailClick: function() {
                    (0,pricing/* activateTrialSubscription */.um)().then(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            auth.reloadUser()
                                        ];
                                    case 1:
                                        _state.sent();
                                        setIsTrialModalOpen(false);
                                        router.replace("/trial/success");
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(response) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container py-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection, {
                    title: "Find **your plan**",
                    description: "",
                    comparisonTable: content.comparison_table,
                    plans: plans.map(function(it) {
                        var currencyObj = currency_min_default()(it.price, {
                            fromCents: true,
                            symbol: "",
                            separator: "",
                            decimal: ","
                        });
                        return {
                            featured: it.featured,
                            features: it.features,
                            id: it.id,
                            title: it.name,
                            price: currencyObj.format(),
                            currency: "€",
                            description: it.description,
                            duration: it.duration,
                            trialDuration: it.trial_duration,
                            active: (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.product_id) === it.id,
                            isTrialSubscriptionActive: isTrialSubscriptionActive,
                            hasActiveSubscription: !!(currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.product_id)
                        };
                    }),
                    onSelect: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(plan) {
                            var ref, subscribe;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!auth.isAuthenticated) {
                                            auth.redirectToLogin({
                                                next: "/pricing"
                                            });
                                            return [
                                                2
                                            ];
                                        }
                                        if ((auth === null || auth === void 0 ? void 0 : (ref = auth.user) === null || ref === void 0 ? void 0 : ref.trialAvailable) && !currentSubscription) {
                                            setIsTrialModalOpen(true);
                                            return [
                                                2
                                            ];
                                        }
                                        if (loading) {
                                            return [
                                                2
                                            ];
                                        }
                                        setLoading(true);
                                        subscribe = function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                                var id, subscription, shouldCancelSubscription, err, replace, err1;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            id = param.id, subscription = param.subscription, shouldCancelSubscription = param.shouldCancelSubscription;
                                                            if (!(shouldCancelSubscription && subscription.id)) return [
                                                                3,
                                                                4
                                                            ];
                                                            _state.label = 1;
                                                        case 1:
                                                            _state.trys.push([
                                                                1,
                                                                3,
                                                                ,
                                                                4
                                                            ]);
                                                            return [
                                                                4,
                                                                (0,pricing/* cancelSubscription */.EO)(subscription.id).then(function(response) {
                                                                    if ((response === null || response === void 0 ? void 0 : response.status) !== "SUCCESS") {
                                                                        throw new Error("Failed to cancel subscription");
                                                                    }
                                                                })
                                                            ];
                                                        case 2:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                4
                                                            ];
                                                        case 3:
                                                            err = _state.sent();
                                                            alert(err);
                                                            return [
                                                                3,
                                                                4
                                                            ];
                                                        case 4:
                                                            _state.trys.push([
                                                                4,
                                                                6,
                                                                ,
                                                                7
                                                            ]);
                                                            replace = (subscription === null || subscription === void 0 ? void 0 : subscription.product_id) && (subscription === null || subscription === void 0 ? void 0 : subscription.product_id) !== id;
                                                            return [
                                                                4,
                                                                (0,pricing/* subscribeToProduct */.AZ)(plan.id, {
                                                                    replace: replace
                                                                }).then(function(response) {
                                                                    if (!(response === null || response === void 0 ? void 0 : response.stripe_public_key) || !(response === null || response === void 0 ? void 0 : response.session_id)) {
                                                                        throw new Error("Not public key or session id");
                                                                    }
                                                                    getStripe(response.stripe_public_key).then(function(stripe) {
                                                                        stripe.redirectToCheckout({
                                                                            sessionId: response.session_id
                                                                        });
                                                                    });
                                                                })
                                                            ];
                                                        case 5:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                7
                                                            ];
                                                        case 6:
                                                            err1 = _state.sent();
                                                            alert("Something went wrong");
                                                            return [
                                                                3,
                                                                7
                                                            ];
                                                        case 7:
                                                            setLoading(false);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function subscribe(_) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }();
                                        return [
                                            4,
                                            subscribe({
                                                id: plan.id,
                                                subscription: futureSubscription || currentSubscription,
                                                shouldCancelSubscription: !!futureSubscription
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(plan) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages_pricing = (PricingPage);


/***/ }),

/***/ 26546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pricing-comparison-table":"PricingComparsionTable_pricing-comparison-table__4_1Z2","pricing-comparison-table__row--striped":"PricingComparsionTable_pricing-comparison-table__row--striped__MeUZN","pricing-comparison-table__cell--featured":"PricingComparsionTable_pricing-comparison-table__cell--featured__gzrPI","pricing-comparison-table__cell--highlighted":"PricingComparsionTable_pricing-comparison-table__cell--highlighted__o0Rs4","pricing-comparison-table__price-text":"PricingComparsionTable_pricing-comparison-table__price-text__1KiZR","pricing-comparison-table__duration":"PricingComparsionTable_pricing-comparison-table__duration__t0k6L","pricing-comparison-table__currency":"PricingComparsionTable_pricing-comparison-table__currency__Qed5V"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2390,9774,2888,179], function() { return __webpack_exec__(74223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);